import React, { useState, useEffect, useContext, useReducer } from "react";
import { Dropdown, Layout, Menu, Modal, Tooltip } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import Card from "../Card/Card";
import InvertedPrimaryButton from "../InvertedPrimaryButton/InvertedPrimaryButton";
import Typography from "../Typography/Typography";
import Icons from "../Icons/Icons";
import ComplianceForm from "../ComplianceForm/ComplianceForm";
import Dropdown_but from "../Dropdown/Dropdown";
import {
  ADD_ENVIRONMENT,
  UPDATE_ANALYTICS,
  UPDATE_COMPLIANCE_FORM_STATUS,
  UPDATE_CREATOR_LINKAGE_MODULE_STATUS,
  UPDATE_ENVIRONMENT_BASE_URL,
} from "../../storage/reducers/types";
import { UserContext, WarehouseContext } from "../../storage/context";
import {
  creatorModuleProductID,
  Creators,
  Developers,
  MEETING_SCHEDULE_LINK,
  Production,
  Sandbox,
  Staging,
  SUBMITTED,
} from "../../constants/constants";
import parse from "html-react-parser";
import getModal from "../../constants/modal";
import ConnectedAccountsCard from "../ConnectedAccountsCard/ConnectedAccountsCard";
import { analyticsReducer, userProfileReducer, USER_PROFILE_DEFAULT_STATE } from "../../storage/reducers";
import ContactSalesCard from "../ContactSalesCard/ContactSalesCard";
import { complianceFormApi, tenantInfoApi } from "../../api";
import { ENVIRONMENT_CHANGED, trackEvent, updateAnalyics } from "../../analytics";
import { useFetchTenantInformation } from "../../hooks/useFetchTenantInformation";
const { Sider } = Layout;

export default function Sidebar({ onContactSalesClick, currentTab }) {
  const {
    warehouse,
    warehouse: { productionKeys },
    dispatchWarehouse,
  } = useContext(WarehouseContext);
  const [activeTab, setActiveTab] = useState("getting-started");
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSalesCard, setShowSalesCard] = useState(false);
  const [isComplianceFormFilled, setIsComplianceFormFilled] = useState(warehouse.isComplianceFormFilled);
  const { userProfile, dispatchUserProfile } = useContext(UserContext);
  const [isSalesModalOpen, setIsSalesModalOpen] = useState(false);
  const [analytics, dispatchAnalytics] = useReducer(analyticsReducer, JSON.parse(localStorage.getItem("phyllo_analytics")));
  const fetchTenantInformation = useFetchTenantInformation();
  let isProductionAvailableForCreatorModule =
    productionKeys.productionEnabledTenantProducts.filter((product) => product.product_id === creatorModuleProductID).length > 0;

  const dropDownKeysBasedOnCurrentTab = {
    Creators: [
      {
        icon: <Icons.staging_circle />,
        key: Staging,
        tooltip: "Connect real accounts and fetch real data for internal development.",
      },
      {
        icon: <Icons.prod_circle />,
        key: Production,
        tooltip: "Manage live user accounts and your Phyllo usage.",
      },
    ],
    Developers: [
      {
        icon: <Icons.sandbox_circle />,
        key: Sandbox,
        tooltip: "Explore Phyllo APIs with dummy data.",
      },
      {
        icon: <Icons.staging_circle />,
        key: Staging,
        tooltip: "Connect real accounts and fetch real data for internal development.",
      },
      {
        icon: <Icons.prod_circle />,
        key: Production,
        tooltip: "Manage live user accounts and your Phyllo usage.",
      },
    ],
  };

  useEffect(() => {
    const pathName = location.pathname.slice(1);
    setActiveTab(pathName);
  }, [location]);

  useEffect(() => {
    (async () => {
      let response = await complianceFormApi.getComplianceFormStatus();
      if (response.data.status === SUBMITTED) {
        setIsComplianceFormFilled(true);
        dispatchWarehouse({
          type: UPDATE_COMPLIANCE_FORM_STATUS,
          payload: true,
        });
      }
    })();
  }, [dispatchAnalytics]);

  const stagingInfoModal = {
    title: "You are in staging environment",
    content: ` <p>✦  Access <b>25 live account</b> connections.</p>
                  <p>✦  Connect <b>real accounts</b> and fetch real data.</p>
                  <p>✦  Use staging for <b>internal development</b> and testing.</p>
                  <p>✦  <b>Don't use</b> staging credentials in actual production environment.</p>`,
    buttonLabel: "Got it!",
    closable: false,
  };

  const afterSubmitFormModal = {
    title: "Thank you for applying for production access to Phyllo APIs!",
    content: ` <p >✦  Our <b>team will be in touch</b> with you shortly.</p>
                  <p >✦  <b>Got questions?</b> Email <a href="mailto:support@getphyllo.com">
                  <u>support@getphyllo.com.</u>
                </a></p>
                  <p >✦  <b>Need product guidance?</b> <a style={{color: "#2262ED"}}
                  href=${MEETING_SCHEDULE_LINK}
                  target="_blank"
                  rel="noreferrer"
                >
                  <u>Book a meeting.</u>
                </a>`,
    buttonLabel: "Got it!",
    closable: true,
  };

  const dispatchSelected = (env) => {
    env = env.toLowerCase();
    let modalObj = getModal(stagingInfoModal);
    let prevEnv = warehouse.environment.current;
    let currEnv = env;

    if (env === Staging) {
      if (currentTab === Developers) {
        !isSalesModalOpen && Modal.info(modalObj);
        setIsSalesModalOpen(true);
      }
    }

    if (env === Production) {
      if (currentTab === Developers && !productionKeys.isAvailable) {
        env = prevEnv;
        setShowSalesCard(true);
        // if (!isComplianceFormFilled) {
        //   setIsModalOpen(true);
        // } else {
        //   let modalObj = getModal(afterSubmitFormModal);
        //   Modal.info(modalObj);
        // }
      } else {
        if (currentTab === Creators && !isProductionAvailableForCreatorModule) {
          env = prevEnv;
          setShowSalesCard(true);
        }
      }
    }
    if (env === Staging) {
      setShowSalesCard(true);
    }
    if (env === Sandbox) setShowSalesCard(false);
    localStorage.setItem("currentEnv", env);
    dispatchWarehouse({ type: ADD_ENVIRONMENT, payload: env });
    dispatchWarehouse({
      type: UPDATE_ENVIRONMENT_BASE_URL,
      payload: warehouse.environment.environmentURLMapping[env],
    });
    dispatchUserProfile({ type: ADD_ENVIRONMENT, payload: env });
    dispatchAnalytics({
      type: UPDATE_ANALYTICS,
      payload: {
        environment: env,
      },
    });

    trackEvent(ENVIRONMENT_CHANGED, {
      from_environment: prevEnv,
      to_environment: currEnv,
    });
  };
  const navigate = useNavigate();
  return (
    <>
      <Sider width={225} className="site-layout-sider">
        <div className="side-bar-container">
          <div>
            {/* {currentTab === Developers && ( */}
            <div className="dropDownContainer">
              <Dropdown_but
                products={dropDownKeysBasedOnCurrentTab[currentTab]}
                icons={true}
                selected={warehouse.environment.current}
                setIsSelected={dispatchSelected}
                isComplianceFormFilled={isComplianceFormFilled}
                isProductionKeysAvailable={productionKeys.isAvailable}
                currentTab={currentTab}
                isProductionAvailableForCreatorModule={isProductionAvailableForCreatorModule}
              />
            </div>
            {/* )} */}
            <Menu
              className="side-bar-menu"
              mode="inline"
              // selectedKeys={["api-credentials"]}
              // defaultOpenKeys={[1]}
              style={{
                marginTop: "12px",
              }}
              // items={pages}
              // style={{ marginTop: "12px" }}
            >
              {tabs[currentTab].map((menuTab) => {
                return (
                  <Menu.Item
                    // defaultValue={""}
                    // defaultChecked={true}
                    // defaultActiveFirst={true}
                    onClick={() => navigate(menuTab.key)}
                    key={menuTab.title}
                    // defaultChecked={menuTab.default}
                    // defaultSelectedKeys={}
                    className={`menu-item-on-sider ${activeTab.includes(menuTab.key) ? "ant-menu-item-selected" : ""}`}
                  >
                    <div className="side-bar-menu-item">
                      {menuTab.icon}
                      <span className="sider-menu-item-title">{menuTab.label}</span>
                    </div>
                  </Menu.Item>
                );
              })}
            </Menu>
          </div>
          <div style={{ marginBottom: "28px" }}>
            {warehouse.environment.current === Staging && <ConnectedAccountsCard currentTab={currentTab} />}
            {/* {!productionKeys.isAvailable && ( */}
            {/* {currentTab === Developers && ( */}
            <ContactSalesCard
            // isComplianceFormFilled={isComplianceFormFilled}
            // onClick={() => {
            //   setIsModalOpen(true);
            // }}
            />
            {/* )} */}
            {/* )} */}
          </div>

          {/* <ComplianceForm
            open={isModalOpen}
            onClose={() => {
              setIsModalOpen(false);
            }}
            setIsComplianceFormFilled={setIsComplianceFormFilled}
          />  */}
        </div>
      </Sider>
    </>
  );
}

// key in this object should be as per the url routes defined.
const tabs = {
  Creators: [
    {
      // component: HelpPage,
      label: "Your Creators",
      key: "creators",
      icon: <Icons.creator_icon />,
    },
  ],
  Developers: [
    {
      label: "Getting started",
      key: "getting-started",
      icon: <Icons.getting_started_icon />,
    },
    {
      // component: WebhookPage,
      label: "API credentials",
      key: "api-credentials",
      icon: <Icons.api_credentials_icon />,
    },
    {
      // component: WebhookPage,
      label: "Webhooks",
      key: "webhooks",
      icon: <Icons.webhook_icon />,
    },
    {
      // component: HelpPage,
      label: "Help",
      key: "help",
      icon: <Icons.help_question_mark_icon />,
    },
  ],
};
